// extracted by mini-css-extract-plugin
export default {"block":"AboutCard_block__-Gwl5","content":"AboutCard_content__D7KtW","line":"AboutCard_line__fFidv","bigTitle":"AboutCard_bigTitle__qMjkO","text":"AboutCard_text__6v7j7"};